module.exports = __webpack_public_path__ + "media/images/delete_icon-5247a6f934bc0301dd3a2f90d2e903d7.png";